module.exports = __webpack_public_path__ + "static/media/flowerparrot.b483c799.gif";